import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_es7mn9nt: FaireBrandEntity = {
  token: "b_es7mn9nt",
  type: "brand",
  name: "EMESLY",
  avatarUrl:
    "https://cdn.faire.com/fastly/bddd081852261b680bc13ab36f729ebf396f8c1e14f8a0f3d5e2b26d292c4c11.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dff424276bd69b2f6a049444b78c4c5100f6befec252a56a54d38ef02a70bdfa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bddd081852261b680bc13ab36f729ebf396f8c1e14f8a0f3d5e2b26d292c4c11.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dff424276bd69b2f6a049444b78c4c5100f6befec252a56a54d38ef02a70bdfa.jpeg",
  location: "Astoria, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 4,
  isInsider: true,
  description:
    "At Emesly, our mission is to curate and carry the best lifestyle products to empower every individual to feel more confident and beautiful!\n\nWe put our utmost care while selecting and developing our products and coupled with our excellent customer service we are able to deliver an experience to our customers that would want them to share it with their family and friends (the same way we do!).\n\nExperience the Emesly difference today!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:47.576Z",
    importedBy: "entity-db-cli",
  },
};
